// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.tb-worksheet-button-left {
    height: 25px;
    padding: 0px 2px;
    margin: 0px 2px;
    opacity: 0.2;
    float: left;
}

.tb-worksheet-button-right {
    height: 25px;
    padding: 0px 2px;
    margin: 0px 2px;
    opacity: 0.2;
    float: right;
}

tr:hover .tb-worksheet-button-left {
    opacity: 1;
}

tr:hover .tb-worksheet-button-right {
    opacity: 1;
}


.tb-worksheet-buttons {
    background-color: #800;
}


    .tb-worksheet-buttons::after {
        content: "";
        clear: both;
        display: table;
    }

.tb-worksheet-tooltip {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.85);
    padding: 2px 10px;
    color: white;
    border-radius: 3px;
}

.tb-worksheet-menu-list {
    position: absolute;
    background-color: #400;
    padding: 2px 10px;
    color: white;
    border-radius: 3px;
}

.tb-worksheet-title {
    color: #ffffff !important;
    text-align: center !important;
    text-shadow: 0 0 5px #ff0000;
}

.tb-worksheet-text {
    color: #808080 !important;
}

.tb-worksheet-currency {
    color: #ffffff !important;
    text-align: right !important;
}

.tb-worksheet-section-text {
    color: #008080 !important;
}

.tb-worksheet-section-currency {
    color: #00ffff !important;
    text-align: right !important;
}

.tb-worksheet-category-text {
    color: #008000 !important;
}

.tb-worksheet-category-currency {
    color: #00cc00 !important;
    text-align: right !important;
}

.tb-worksheet-account-text {
    color: #c0c080 !important;
}

.tb-worksheet-account-currency {
    color: #ffff00 !important;
    text-align: right !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/budgetWorksheet/views/BudgetWorksheet.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,sBAAsB;AAC1B;;;IAGI;QACI,WAAW;QACX,WAAW;QACX,cAAc;IAClB;;AAEJ;IACI,kBAAkB;IAClB,qCAAqC;IACrC,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC","sourcesContent":["\r\n.tb-worksheet-button-left {\r\n    height: 25px;\r\n    padding: 0px 2px;\r\n    margin: 0px 2px;\r\n    opacity: 0.2;\r\n    float: left;\r\n}\r\n\r\n.tb-worksheet-button-right {\r\n    height: 25px;\r\n    padding: 0px 2px;\r\n    margin: 0px 2px;\r\n    opacity: 0.2;\r\n    float: right;\r\n}\r\n\r\ntr:hover .tb-worksheet-button-left {\r\n    opacity: 1;\r\n}\r\n\r\ntr:hover .tb-worksheet-button-right {\r\n    opacity: 1;\r\n}\r\n\r\n\r\n.tb-worksheet-buttons {\r\n    background-color: #800;\r\n}\r\n\r\n\r\n    .tb-worksheet-buttons::after {\r\n        content: \"\";\r\n        clear: both;\r\n        display: table;\r\n    }\r\n\r\n.tb-worksheet-tooltip {\r\n    position: absolute;\r\n    background-color: rgba(0, 0, 0, 0.85);\r\n    padding: 2px 10px;\r\n    color: white;\r\n    border-radius: 3px;\r\n}\r\n\r\n.tb-worksheet-menu-list {\r\n    position: absolute;\r\n    background-color: #400;\r\n    padding: 2px 10px;\r\n    color: white;\r\n    border-radius: 3px;\r\n}\r\n\r\n.tb-worksheet-title {\r\n    color: #ffffff !important;\r\n    text-align: center !important;\r\n    text-shadow: 0 0 5px #ff0000;\r\n}\r\n\r\n.tb-worksheet-text {\r\n    color: #808080 !important;\r\n}\r\n\r\n.tb-worksheet-currency {\r\n    color: #ffffff !important;\r\n    text-align: right !important;\r\n}\r\n\r\n.tb-worksheet-section-text {\r\n    color: #008080 !important;\r\n}\r\n\r\n.tb-worksheet-section-currency {\r\n    color: #00ffff !important;\r\n    text-align: right !important;\r\n}\r\n\r\n.tb-worksheet-category-text {\r\n    color: #008000 !important;\r\n}\r\n\r\n.tb-worksheet-category-currency {\r\n    color: #00cc00 !important;\r\n    text-align: right !important;\r\n}\r\n\r\n.tb-worksheet-account-text {\r\n    color: #c0c080 !important;\r\n}\r\n\r\n.tb-worksheet-account-currency {\r\n    color: #ffff00 !important;\r\n    text-align: right !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
